module.exports = __webpack_public_path__ + "img/2.656ca2f7.svg";